<template>
  <v-card class="pa-4">
    <h3 class="text-center">
      {{ isEditing ? 'Editar' : 'Adicionar' }} documento
    </h3>

    <v-form ref="form" v-model="formValid">
      <v-row class="ma-0" dense>
        <v-col cols="12">
          <label for="name">Nome</label>
          <v-text-field
            v-model="document.identification"
            outlined
            class="primary-input"
            :rules="[(v) => !!v || 'Nome obrigatório']"
            placeholder="Nome do documento"
            hide-details="auto"
            :loading="loading"
          ></v-text-field>
        </v-col>
        <v-col cols="12">
          <label for="name">Pastas</label>
          <v-select
            v-model="document.folderId"
            outlined
            append-icon="mdi-chevron-down"
            class="primary-input"
            :disabled="!!parentFolderId"
            :items="folders"
            item-text="name"
            item-value="id"
            placeholder="Pastas do documento"
            hide-details="auto"
            :loading="folderLoading || loading"
          ></v-select>
        </v-col>
        <v-col cols="12">
          <label for="name">Documento</label>
          <v-file-input
            :placeholder="
              isEditing
                ? `${document.identification}.${document.extension}`
                : 'Upload do Documento'
            "
            v-model="document.file"
            outlined
            prepend-icon=""
            hide-details="auto"
            :disabled="isEditing"
            class="primary-input"
            :rules="
              isEditing
                ? []
                : [(v) => !!v || 'Upload do Documento é obrigatório']
            "
            prepend-inner-icon="mdi-file"
            :loading="loading"
          ></v-file-input>
        </v-col>
        <v-col cols="12" class="d-flex justify-space-between">
          <v-btn
            class="primary-button ma-1"
            depressed
            :disabled="formLoading"
            @click="$emit('close')"
          >
            Cancelar
          </v-btn>
          <v-btn
            class="secondary-button ma-1"
            depressed
            :loading="formLoading"
            :disabled="!formValid"
            @click="submit"
          >
            {{ isEditing ? 'Atualizar' : 'Adicionar' }}
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </v-card>
</template>

<script>
import ApiService from '../../../../services/ApiService'
import moment from 'moment'
export default {
  name: 'PopsManageDocument',

  components: {},

  props: {
    documentId: Number,
    parentFolderId: Number,
    engType: Number,
  },

  data() {
    return {
      alert: {},
      isEditing: false,
      dialogKey: false,
      alertDialog: false,
      apiService: new ApiService(),
      document: {},
      loading: false,
      folders: [],
      formValid: false,
      folderLoading: false,
      formLoading: false,
    }
  },

  created() {
    this.getFolders()
    if (this.documentId) {
      this.isEditing = true
      this.document.file = this.document.filePath
      this.getDocument()
    }
    console.log(this.document)

    if (this.parentFolderId) this.document.folderId = this.parentFolderId
    this.document.engType = this.engType
  },

  methods: {
    formatDate() {
      return this.document.expireDate
        ? moment(this.document.expireDate).format('DD/MM/yyyy')
        : ''
    },

    getDocument() {
      this.loading = true
      this.apiService
        .get(`PopDocument/${this.documentId}`)
        .then((response) => {
          this.document = response.content

          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },

    getFolders() {
      this.folderLoading = true
      this.apiService
        .get(`PopDocumentFolder/list-clinic`)
        .then((response) => {
          this.folders = response.content
          this.folderLoading = false
        })
        .catch(() => {
          this.folderLoading = false
        })
    },

    submit() {
      if (this.isEditing) this.edit()

      const reader = new FileReader()
      reader.readAsDataURL(this.document.file)

      reader.onload = () => {
        const extension = this.document.file.name.split('.').pop()
        const base64String = reader.result

        this.document.filePath = base64String
        this.document.extension = extension

        const fileSize = this.document.file.size
        this.document.size = fileSize
        this.document.engType = this.engType

        this.add()
      }
    },

    edit() {
      if (!this.$refs.form.validate()) return

      this.formLoading = true

      this.apiService
        .put('PopDocument/edit', this.document)
        .then((response) => {
          this.$toast.success('Arquivo atualizado com sucesso!')
          this.$emit('success')
          this.formLoading = false
        })
        .catch(() => {
          this.formLoading = false
        })
    },

    add() {
      if (!this.$refs.form.validate()) return

      this.formLoading = true
      this.document.engType = 0
      this.apiService
        .post('PopDocument/add', this.document)
        .then((response) => {
          console.log(this.engType)
          this.$toast.success('Arquivo adicionado com sucesso! O processamento pela IA será feito em segundo plano.')
          this.$emit('success')
          this.$emit('totalFilesUpdate')
          this.formLoading = false
        })
        .catch(() => {
          this.formLoading = false
        })
    },
  },
}
</script>

<style></style>
